module.exports = __webpack_public_path__ + "img/thumbnail_MuteSwan_m_leucistic.20e816c7.png";